var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipse1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 720,
    height: 661,
    viewBox: "0 0 720 661",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3406_3367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M674.5 53.746C674.5 173.316 527.5 460.746 197 460.746C77.4304 460.746 72 368.981 72 249.412C72 129.842 190.93 6.91122 310.5 6.91122C430.07 6.91122 674.5 -65.8236 674.5 53.746Z",
    fill: "url(#paint0_linear_3406_3367)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3406_3367",
    x: -128,
    y: -215,
    width: 1002.5,
    height: 875.746,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_3406_3367"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3406_3367",
    x1: 373.25,
    y1: -15,
    x2: 373.25,
    y2: 460.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0061FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111827",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse1);
export default __webpack_public_path__ + "static/media/ellipse-1.ae1496f867ad7a0d7861b380b840027f.svg";
export { ForwardRef as ReactComponent };